import React from 'react/addons';
import {gettext} from 'ofs/i18n';
import TextField from 'ofs/react/fields/textfield';
import SelectField from 'ofs/react/fields/selectfield';

const messages = {
  NAME_OF_PLACE: gettext('Name of place'),
  ADDRESS_OF_PLACE: gettext('Address of place'),
  GOOGLE_MAPS: gettext('Google Maps link'),
  AT_THE_HOME: gettext('At the home'),
  OTHER: gettext('Other'),
};

const ExternalAppointment = React.createClass({
  render() {
    const model = this.props.model.appointment || this.props.model;

    const placeTypeChoices = [
      {value: 'home', name: messages.AT_THE_HOME},
      {value: 'external', name: messages.OTHER},
    ];

    const isExternal = model.get('appointment_place_type') === 'external';

    return (
      <div className="external-appointment admin-only">
        <SelectField options={placeTypeChoices} label="Place of appointment (admin)" name="appointment_place_type" model={model} field="appointment_place_type" />
        {isExternal ? <TextField label={messages.NAME_OF_PLACE} name="external_location" model={model} field="external_location" /> : null}
        {isExternal ? <TextField label={messages.ADDRESS_OF_PLACE} name="external_address" model={model} field="external_address" /> : null}
        {isExternal ? <TextField label={messages.GOOGLE_MAPS} name="external_map_link" model={model} field="external_map_link" /> : null}
      </div>
    );
  }
});

export default ExternalAppointment;


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/views/_ExternalAppointment.jsx
 **/